import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {CpfCnpjPipe} from '../../../shared/pipes/cpfCnpj.pipe';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {ContratoArrendamento} from '../../../models/arrendamento/contrato-arrendamento.model';
import {VeiculoSimples} from '../../../models/arrendamento/veiculo-simples.model';
import {ContratoArrendamentoService} from '../../../services/contrato-arrendamento.service';
import {DocumentoService} from '../../../services/documento.service';
import {ModalService} from '../../../services/modal.service';
import {BuscarVeiculoContratoArrendamentoComponent} from '../buscar-veiculo/buscar-veiculo-contrato-arrendamento.component';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
    selector: 'cadastro-contrato-arrendamento',
    templateUrl: 'cadastro-contrato-arrendamento.component.html',
    styleUrls: ['cadastro-contrato-arrendamento.component.scss'],
    providers: [CpfCnpjPipe]
})

export class CadastroContratoArrendamentoComponent implements OnInit {
    @ViewChild('form', {static:  true})
    form: NgForm;

    @ViewChild('arrendamentoComponent',  {static: true})
    buscaVeiculoComponent: BuscarVeiculoContratoArrendamentoComponent;

    uploadFormGroup1: FormGroup;
    uploadFormGroup2: FormGroup;

    contrato: ContratoArrendamento = {
        cienciaPena: false,
        contratoValido: false,
        cpfCnpjArrendatario: '',
        cpfCnpjArrendante: '',
        dataValidadeFim: '',
        dataValidadeInicio: '',
        nomeRazaoSocialArrendante: '',
        nomeRazaoSocialArrendatario: '',
        placa: '',
        renavam: ''
    }

    minDate: Date;
    maxDate: Date;
    dataValidadeFim: any = {};
    dataValidadeInicio: any = {};
    showFileSelection = true;
    dataMinimaValida: Date = new Date(1900, 0, 1); // 01/01/1900
    dataMaximaValida: Date = new Date(); // data atual

    af: string[] = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/tiff'];

    constructor(private contratoArrendamentoService: ContratoArrendamentoService,
                private documentoService: DocumentoService,
                private modalService: ModalService,
                private cpfCnpjPipe: CpfCnpjPipe,
                private readonly router: Router
            ) {}

    ngOnInit(): void {
        this.initializeFormUpload();
        this.limparFormulario();
    }

    onVeiculoChangeHandler(veiculo: VeiculoSimples) {
        this.contrato.placa = veiculo.placa;
        this.contrato.renavam = veiculo.renavam;
        this.contrato.cpfCnpjArrendante = this.cpfCnpjPipe.transform(veiculo.cpfCnpjArrendante);
        this.contrato.nomeRazaoSocialArrendante = veiculo.nomeArrendante;
    }

    onCpfCnpjChangeHandler(cpfCnpj: string, field = '') {
        this.contrato[field] = cpfCnpj;
    }

    cadastrarContrato() {
        const contrato: ContratoArrendamento = {
            placa: this.buscaVeiculoComponent.valorPesquisa,
            renavam: this.contrato.renavam,
            cienciaPena: this.contrato.cienciaPena,
            contratoValido: this.contrato.contratoValido,
            dataValidadeFim: this._dateFormatter(this.dataValidadeFim),
            dataValidadeInicio: this._dateFormatter(this.dataValidadeInicio),
            nomeRazaoSocialArrendante: this.contrato.nomeRazaoSocialArrendante,
            nomeRazaoSocialArrendatario: this.contrato.nomeRazaoSocialArrendatario,
            cpfCnpjArrendante: (this.contrato.cpfCnpjArrendante ? this.contrato.cpfCnpjArrendante.replace(/[^0-9]+/g, '') : null),
            cpfCnpjArrendatario: (this.contrato.cpfCnpjArrendatario ? this.contrato.cpfCnpjArrendatario.replace(/[^0-9]+/g, '') : null)
        }

        this.contratoArrendamentoService.criarContrato(contrato).subscribe(
            result => {
                if (result) {
                    const codigoPedido = result.data ? result.data.codigoPedido : 0;

                    if(this.uploadFormGroup1.valid) {
                        const fileFormData1: FormData = new FormData();
                        fileFormData1.append('file', this.uploadFormGroup1.controls.fileUpload.value, this.uploadFormGroup1.controls.filename.value);
                        fileFormData1.append('descricao', 'Certificado de Registro e Licenciamento do Veiculo');
                        fileFormData1.append('idArrendamento', result.data.idArrendamento);
                        
                        this.documentoService.upload(fileFormData1, this.contrato.cpfCnpjArrendatario.replace(/[^0-9]+/g, '')).subscribe(
                            resp => {
                              // nada a fazer
                            },
                            erro => {
                              if(erro.message){
                                this.modalService.error(erro.message);
                              }
                              else {
                                this.modalService.error('Estamos com problemas técnicos. Tente novamente mais tarde.');
                              }
                            }
                        )
                    }

                    if(this.uploadFormGroup2.valid) {
                        const fileFormData2: FormData = new FormData();
                        fileFormData2.append('file', this.uploadFormGroup2.controls.fileUpload.value, this.uploadFormGroup2.controls.filename.value);
                        fileFormData2.append('descricao', 'Contrato de Arrendamento');
                        fileFormData2.append('idArrendamento', result.data.idArrendamento);
                        
                        this.documentoService.upload(fileFormData2, this.contrato.cpfCnpjArrendatario.replace(/[^0-9]+/g, '')).subscribe(
                            resp => {
                                 if (codigoPedido && codigoPedido > 0) 
                                    this.router.navigate([`/portal/cadastro/veiculo/movimentacao/pagamento/${codigoPedido}/arrendamento`]);


                              this.initializeFormUpload();
                            },
                            erro => {
                              if(erro.message){
                                this.modalService.error(erro.message);
                              }
                              else {
                                this.modalService.error('Estamos com problemas técnicos. Tente novamente mais tarde.');
                              }
                            }
                        )
                    }
                }
                else {
                    this.modalService.success('O Contrato arrendamento não foi cadastrado. Tente novamente.');
                }                    

                this.limparFormulario();
            },
            error => {
                if (error.error.errors[0].message.length) {
                    this.modalService.error(error.error.errors[0].message);
                } else {
                    this.modalService.error(error.error.message);
                }
            }
        );
    }


    desabilitarBotaoIncluir() {
        let naoHabilita = false;

        if (this.form.invalid) naoHabilita = true;
        if (this.buscaVeiculoComponent.valorPesquisa.trim().length < 7) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendante) && (this.contrato.cpfCnpjArrendante.length < 14)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendante) && (this.contrato.cpfCnpjArrendante.length > 14 && this.contrato.cpfCnpjArrendante.length < 18)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendatario) && (this.contrato.cpfCnpjArrendatario.length < 14)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendatario) && (this.contrato.cpfCnpjArrendatario.length > 14 && this.contrato.cpfCnpjArrendatario.length < 18)) naoHabilita = true;
        if ((this.contrato.nomeRazaoSocialArrendante) && (this.contrato.nomeRazaoSocialArrendante.length < 2)) naoHabilita = true;
        if ((this.contrato.nomeRazaoSocialArrendatario) && (this.contrato.nomeRazaoSocialArrendatario.length < 2)) naoHabilita = true;
        if (this.uploadFormGroup1.invalid) naoHabilita = true;
        if (this.uploadFormGroup2.invalid) naoHabilita = true;

        return naoHabilita;
    }

    initializeFormUpload(){
        this.uploadFormGroup1 = new FormGroup({
            filename: new FormControl('', [Validators.required]),
            fileUpload: new FormControl('', [Validators.required])
        });

        this.uploadFormGroup2 = new FormGroup({
            filename: new FormControl('', [Validators.required]),
            fileUpload: new FormControl('', [Validators.required])
        });
    }
    
    limparFormulario() {
        this.buscaVeiculoComponent.valorPesquisa = '';

        this.form.control.reset();
        this.form.control.markAsUntouched();
        this.uploadFormGroup1.reset();
        this.uploadFormGroup2.reset();

        Object.keys(this.form.control.controls).forEach(name => {
            const control = this.form.control.controls[name];

            control.setErrors(null);
        })
    }

    maxDateChangeHandler(event: MatDatepickerInputEvent<Date>) {
        this.maxDate = event.value;
        this.outFocusDate();
    }

    minDateChangeHandler(event: MatDatepickerInputEvent<Date>) {
        this.minDate = event.value;
        this.outFocusDate();
    }

    private _dateFormatter(value: any): string {
        return `${moment(value).format('YYYY-MM-DD HH:mm:ss')}`;
    }

    uploadFile1(files: FileList) {
        if (!_.includes(this.af, files.item(0).type)) {
          this.modalService.important('Somente arquivo pdf ou imagem é permitido !');
        } else {
          this.uploadFormGroup1.controls.fileUpload.setValue(files.item(0));
          this.uploadFormGroup1.controls.filename.setValue(files.item(0).name);
        }
    }

    uploadFile2(files: FileList) {
        if (!_.includes(this.af, files.item(0).type)) {
          this.modalService.important('Somente arquivo pdf ou imagem é permitido !');
        } else {
          this.uploadFormGroup2.controls.fileUpload.setValue(files.item(0));
          this.uploadFormGroup2.controls.filename.setValue(files.item(0).name);
        }
    }

    
    validateDate() {
        this.form.controls["dataFim"].setErrors(null);

        if (this.isDateInitialBigger()) {
            this.form.controls["dataFim"].setErrors({ 'erroDataMenorInicio': true});
            this.form.controls["dataFim"].markAsTouched();
        } 
        
        this.form.control.updateValueAndValidity();
    }

    outFocusDate() {
        this.validateDate();
        this.form.controls["dataInicio"].setErrors(null);

        if (
            this.form.controls["dataInicio"].value == null 
            || this.form.controls["dataInicio"].value == ''
            || Object.keys(this.form.controls["dataInicio"].value).length === 0
        ) {
            this.form.controls["dataInicio"].setErrors({ 'customError': true});
            this.form.controls["dataInicio"].markAsTouched();    
        }
        this.form.control.updateValueAndValidity();
    }

    isDateInitialBigger = (): boolean => (this.dataValidadeInicio != null && Object.keys(this.dataValidadeInicio).length !== 0)
         && (this.dataValidadeFim != null && Object.keys(this.dataValidadeFim).length !== 0)
         && this.dataValidadeInicio.isSameOrAfter(this.dataValidadeFim);
    
}
